// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/precautionary-landing-inspection.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/precautionary-landing-inspection/precautionary-landing-inspection.js';

mount([g0]);
